import React from 'react'

export default function Donate() {
  return (
    <div style={{ }}>
      <span style={{ fontWeight: 'bold' }}>Donate:</span> 0x6efeF34e81FD201EdF18C7902948168E9eBb88aE (philipplgh.eth) <a href="https://twitter.com/philipplgh" target="_blank">@philipplgh</a>
    </div>
  )
}
